import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Pagination from "react-bootstrap/Pagination";

const CustomPagination = ({ data = [], setData = null, pageSize = 5 }) => {
  const [currentPage, set_currentPage] = useState(0);
  const [pageCount, set_pageCount] = useState(0);

  useEffect(() => {
    constructPagination();
  }, [data]);

  function constructPagination() {
    const dataLen = data.length;
    const pgcount =
      dataLen % pageSize === 0
        ? parseInt(dataLen / pageSize)
        : parseInt(dataLen / pageSize) + 1;
    set_pageCount(pgcount);
    paginate(currentPage);
  }

  function paginate(pageNum) {
    set_currentPage(pageNum);
    const start_inx = pageNum * pageSize;
    const page_data = data.slice(start_inx, start_inx + pageSize);
    setData(page_data);
  }

  return (
    <Pagination className="custom-pagination mr-2">
      <Pagination.First onClick={() => paginate(0)} />
      <Pagination.Prev
        disabled={currentPage === 0}
        onClick={() => paginate(currentPage - 1)}
      />
      {Array.from({ length: pageCount }).map((itm, inx) => {
        return (
          <Pagination.Item
            key={inx.toString()}
            active={inx === currentPage}
            onClick={() => paginate(inx)}
          >
            {inx + 1}
          </Pagination.Item>
        );
      })}
      <Pagination.Next
        disabled={currentPage === pageCount - 1}
        onClick={() => paginate(currentPage + 1)}
      />
      <Pagination.Last onClick={() => paginate(pageCount - 1)} />
    </Pagination>
  );
};

Pagination.propTypes = {
  data: PropTypes.array,
  setData: PropTypes.func,
  pageSize: PropTypes.number,
};

export default CustomPagination;
